import { Link } from "react-router-dom";
import { articles } from "@/mocks/categories";

export default function ArticleSection() {
  const featuredArticles = articles.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-4">
            SEO Guides &amp; Resources
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Kakobuy Spreadsheet Knowledge Base
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            In-depth guides, platform comparisons, tutorials, and product discovery resources to help you master the Kakobuy spreadsheet and find the best products.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[10px] font-semibold bg-white/90 text-foreground-800 rounded-full">
                  {article.category}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 leading-snug mb-3 group-hover:text-accent-700 transition-colors duration-300">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm font-medium text-accent-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-sm transition-transform duration-300 group-hover:translate-x-1"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-600 text-white text-sm font-medium rounded-full hover:bg-accent-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Read Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}